/**
 * Получение языка пользователя
 */
import { ApplicationShared } from "core";
import { getCookie, getTopDomain, setCookie } from "../../../../helpers/cookies";
import { DEZIIIGN_CONTEXTS, MEDIIIA_CONTEXTS } from "shared/constants/enginePaths";

const getContextLang = () => {
  const app = ApplicationShared.application;
  if ([
    ...MEDIIIA_CONTEXTS,
    ...DEZIIIGN_CONTEXTS,
    'geograffee/dafes',
    'deziiign/lpudesign'
  ].includes(app)) {
    return 'en';
  }
}

export default function GetUserLang(): 'ru' | 'en' {
  // Пробуем взять из cookie
  const cookieLang = getCookie('brg_lang');
  if (cookieLang === 'ru' || cookieLang === 'en') {
    return cookieLang;
  }

  // Пробуем взять из localStorage
  const storageLang = localStorage.getItem('brg_lang');
  if (storageLang === 'ru' || storageLang === 'en') {
    return storageLang;
  }


  const contextLang = getContextLang();

  if (contextLang) {
    return contextLang;
  }

  // Fallback — язык браузера
  const navLang = navigator.language || (navigator as any).userLanguage;
  return navLang.startsWith('ru') ? 'ru' : 'en';
}

/**
 * Сохраненяем язык который выбрали
 */
export function SaveUserLang(lang: 'ru' | 'en'): void {

  localStorage.setItem('brg_lang', lang);

  const domain = getTopDomain(2);
  setCookie('brg_lang', lang, {
    domain,
  });
}
/**
 * Получение языка пользователя
 */
import { ApplicationShared } from "core";
import { getCookie, getTopDomain, setCookie } from "../../../../helpers/cookies";
import { DEZIIIGN_CONTEXTS, MEDIIIA_CONTEXTS } from "shared/constants/enginePaths";

const getContextLang = () => {
  const app = ApplicationShared.application;
  if ([
    ...MEDIIIA_CONTEXTS,
    ...DEZIIIGN_CONTEXTS,
    'geograffee/dafes',
    'deziiign/lpudesign'
  ].includes(app)) {
    return 'en';
  }
}

export default function GetUserLang(): 'ru' | 'en' {
  // Пробуем взять из cookie
  const cookieLang = getCookie('brg_lang');
  if (cookieLang === 'ru' || cookieLang === 'en') {
    return cookieLang;
  }

  // Пробуем взять из localStorage
  const storageLang = localStorage.getItem('brg_lang');
  if (storageLang === 'ru' || storageLang === 'en') {
    return storageLang;
  }


  const contextLang = getContextLang();

  if (contextLang) {
    return contextLang;
  }

  // Fallback — язык браузера
  const navLang = navigator.language || (navigator as any).userLanguage;
  return navLang.startsWith('ru') ? 'ru' : 'en';
}

/**
 * Сохраненяем язык который выбрали
 */
export function SaveUserLang(lang: 'ru' | 'en'): void {

  localStorage.setItem('brg_lang', lang);

  const domain = getTopDomain(2);
  setCookie('brg_lang', lang, {
    domain,
  });
}
